import {Component} from '@angular/core';
import {EnvService} from "../services/env.service";
import {HttpClient} from "@angular/common/http";
import {BaseComponent} from "../base/base.component";
import { ActivatedRoute, Router, Params } from '@angular/router';
import {AlertService} from "../services/alert.service";
import {AuthService} from "../services/auth.service";

@Component({
  selector: 'micro-ussdSubscriptionServer-detail',
  templateUrl: './ussdSubscriptionServer-detail.component.html'
})
export class UssdSubscriptionServerDetailComponent extends BaseComponent {
  ussdSubscriptionServer:any;

  constructor(protected env: EnvService,
              protected http: HttpClient,
              private route: ActivatedRoute,
              private router:Router,
              private authService:AuthService,
              private alertService:AlertService) {
    super(env, http);
  }

  protected onInit(): void {
    this.route.params
      .subscribe((params: Params) => {
        let id:any = params['id'];
        if (id === '0') {
          this.createNew();
        } else {
          this.http.get(`${this.env.e.url}/ussd/servers/subscription/${id}`).subscribe(
            data => {
              this.setUssdSubscriptionServer(data)
            }
          );
        }
      });
  }

  setUssdSubscriptionServer(ussdSubscriptionServer:any) {
    this.ussdSubscriptionServer = ussdSubscriptionServer;
  }

  createNew() {
    this.ussdSubscriptionServer = {
      name: '',
      port: 7003,
      protocol: 'USA',
      enabled: true,
      maxPendingConnections: 25,
      subTimeoutMillis: 60000,
    };
  }

  save() {
    if (!this.ussdSubscriptionServer.id) {
      this.http.post(`${this.env.e.url}/ussd/servers/subscription`, this.ussdSubscriptionServer)
        .subscribe(
          data => {
            this.setUssdSubscriptionServer(data)
            this.alertService.info(`Created ${this.ussdSubscriptionServer.name}`);
          }
        );
    } else {
      this.http.put(`${this.env.e.url}/ussd/servers/subscription/${this.ussdSubscriptionServer.id}`, this.ussdSubscriptionServer)
        .subscribe(
          data => {
            this.setUssdSubscriptionServer(data)
            this.alertService.info(`Updated`);
          }
        );
    }
  }

  delete() {
    this.http.delete(`${this.env.e.url}/ussd/servers/subscription/${this.ussdSubscriptionServer.id}`)
      .subscribe(
        complete => {
          this.alertService.info(`Deleted ${this.ussdSubscriptionServer.name}`);
          this.router.navigate(["/ussdServers"]);
        }
      );
  }

  hasRole(role:string) {
    if (!role) {
      return true;
    }
    return this.authService.hasRole(role);
  }
}
